import React, { useEffect, useState } from 'react';
import api from '../api';
import './SidebarVideos.css';

function formatDate(dateString) {
  try {
    return new Date(dateString).toLocaleDateString('hi-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch (e) {
    return '';
  }
}

function SidebarVideos() {
  const [videos, setVideos] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  const requestWithFallback = async (path) => {
    const candidates = [
      { baseURL: undefined },
      { baseURL: 'http://localhost:5000' },
      { baseURL: 'http://127.0.0.1:5000' },
    ];

    let lastError;
    for (const candidate of candidates) {
      try {
        const config = { url: path, method: 'get' };
        if (candidate.baseURL) config.baseURL = candidate.baseURL;
        return await api.request(config);
      } catch (err) {
        lastError = err;
        const status = err?.response?.status;
        if (status && status !== 404) break;
      }
    }

    throw lastError;
  };

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);
        setErrorMessage('');
        const res = await requestWithFallback(`/api/videos?page=${page}&limit=6`);
        if (res && res.data && res.data.success) {
          setVideos(Array.isArray(res.data.data) ? res.data.data : []);
          setTotalPages(res.data.pagination?.pages || 1);
        }
      } catch (err) {
        setErrorMessage('वीडियो लोड नहीं हो पाए।');
        console.error('Failed to load sidebar videos:', err?.response?.status, err?.response?.data || err.message || err);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, [page]);

  return (
    <div className="sidebar-widget sidebar-videos-widget">
      <h3 className="widget-title">📺 वीडियो सेक्शन</h3>

      {loading ? (
        <div className="videos-loading">वीडियो लोड हो रहे हैं...</div>
      ) : errorMessage ? (
        <div className="videos-empty">{errorMessage}</div>
      ) : videos.length === 0 ? (
        <div className="videos-empty">अभी कोई वीडियो उपलब्ध नहीं है।</div>
      ) : (
        <div className="videos-list">
          {videos.map((video) => (
            <article key={video._id} className="video-card">
              <div className="video-frame-wrap">
                <iframe
                  src={video.embedUrl}
                  title={video.title}
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
              <h4 className="video-title">{video.title}</h4>
              {video.description && <p className="video-description">{video.description}</p>}
              <div className="video-meta">{formatDate(video.createdAt)}</div>
            </article>
          ))}
        </div>
      )}

      {totalPages > 1 && (
        <div className="videos-pagination">
          <button
            type="button"
            className="videos-page-btn"
            disabled={page <= 1}
            onClick={() => setPage((prev) => Math.max(1, prev - 1))}
          >
            पिछला
          </button>
          <span className="videos-page-info">पेज {page} / {totalPages}</span>
          <button
            type="button"
            className="videos-page-btn"
            disabled={page >= totalPages}
            onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))}
          >
            अगला
          </button>
        </div>
      )}
    </div>
  );
}

export default SidebarVideos;
